import request from '@/utils/request'

const baseUrl = '/erp/sales/report/customer-sales-summary'

export const pageCustomerSalesSummaryReport = params => request({
  url: baseUrl + '/page',
  method: 'get',
  params
})

export const listCustomerSalesSummarySupplierOptions = () => request({
  url: baseUrl + '/supplier-options',
  method: 'get'
})

export const exportCustomerSalesSummaryReport = params => request({
  url: baseUrl + '/export',
  method: 'get',
  params,
  responseType: 'blob'
})
